import { useUserContext } from "@contexts/UserContext/index.context";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import FullPageLoader from "../common/FullPageLoader";
import MainHeader from "../common/header/MainHeader";
import { Unauthorized } from "../common/Unauthorized";

function Authenticated() {
  const { userState } = useUserContext();
  const [isConnected, setIsConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const urlRole = location.pathname.replace(/^\/([^/]*).*$/, "$1");
  const isAuthorized =
    Boolean(urlRole) &&
    Boolean(userState) &&
    userState["custom:role"]?.toLowerCase() === urlRole.toLowerCase();

  useEffect(() => {
    if (userState) {
      setIsLoading(false);
      setIsConnected(userState.connected);
    }
  }, [userState?.connected, userState]);

  return (
    <>
      {isLoading ? (
        <FullPageLoader />
      ) : isConnected && isAuthorized ? (
        <>
          <MainHeader />
          <Outlet />
        </>
      ) : isConnected && !isAuthorized ? (
        <Unauthorized />
      ) : (
        <Navigate
          to="/login"
          state={location.state?.from ? { from: location.state.from } : undefined}
        />
      )}
    </>
  );
}

export default Authenticated;
